export default function NewProjectModal({
  form,
  updateField,
  formInputStyle,
  calculateTotalPersonel,
  calculateKalanAySure,
  saveProject,
  setShowNewProjectModal,
  companyOptions = [],
  technoparkOptions = []
}) {
  const labeledInput = (label, input) => (
    <label style={{ display: "grid", gap: 6, color: "#334155", fontWeight: 700 }}>
      <span>{label}</span>
      {input}
    </label>
  );

  return (
    <div
      onClick={() => {}}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        paddingTop: 40,
        zIndex: 9999
      }}
    >
      <div
        className="force-light-form"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          padding: 32,
          borderRadius: 16,
          width: "95%",
          maxWidth: 1000,
          maxHeight: "92vh",
          overflowY: "auto",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)"
        }}
      >
        <div style={{ borderBottom: "1px solid #eee", paddingBottom: 16, marginBottom: 24 }}>
          <h2 style={{ margin: 0, fontSize: 28 }}>
            Yeni Proje Ekle
          </h2>

          <p style={{ marginTop: 8, color: "#666" }}>
            Yeni proje bilgilerini sisteme ekleyebilirsiniz
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
          {labeledInput(
            "Firma Adı",
            <input list="company-options" style={formInputStyle} placeholder="Firma adı yazın veya listeden seçin" value={form.firmaAdi} onChange={(e) => updateField("firmaAdi", e.target.value)} />
          )}
          <datalist id="company-options">
            {companyOptions.map((company) => (
              <option key={company.firmaAdi} value={company.firmaAdi}>
                {company.firmaKisaAdi ? `${company.firmaKisaAdi} - ${company.firmaAdi}` : company.firmaAdi}
              </option>
            ))}
          </datalist>

          {labeledInput(
            "Firma Kısa Adı",
            <input style={formInputStyle} placeholder="Firma kısa adı" value={form.firmaKisaAdi || ""} onChange={(e) => updateField("firmaKisaAdi", e.target.value)} />
          )}

          {labeledInput(
            "Teknopark",
            <input list="technopark-options" style={formInputStyle} placeholder="Teknopark yazın veya listeden seçin" value={form.teknoparkAdi} onChange={(e) => updateField("teknoparkAdi", e.target.value)} />
          )}
          <datalist id="technopark-options">
            {technoparkOptions.map((teknopark) => (
              <option key={teknopark} value={teknopark} />
            ))}
          </datalist>

          <select style={formInputStyle} value={form.projeKategorisi} onChange={(e) => updateField("projeKategorisi", e.target.value)}>
            <option value="">Proje Kategorisi Seç</option>
            <option value="Yazılım">Yazılım</option>
            <option value="Ar-Ge">Ar-Ge</option>
            <option value="Tasarım">Tasarım</option>
          </select>

          <input style={formInputStyle} placeholder="STB Kodu" value={form.projeStbKodu} onChange={(e) => updateField("projeStbKodu", e.target.value)} />

          <input
            style={{ ...formInputStyle, gridColumn: "1 / 3" }}
            placeholder="Proje Adı"
            value={form.projeAdi}
            onChange={(e) => updateField("projeAdi", e.target.value)}
          />

          <h3 style={{ gridColumn: "1 / 3", marginBottom: 0 }}>Personel Bilgileri</h3>

          {labeledInput(
            "Ar-Ge Personeli",
            <input type="number" min="0" style={formInputStyle} placeholder="0" value={form.argePersoneli} onChange={(e) => updateField("argePersoneli", e.target.value)} />
          )}
          {labeledInput(
            "Yazılım Personeli",
            <input type="number" min="0" style={formInputStyle} placeholder="0" value={form.yazilimPersoneli} onChange={(e) => updateField("yazilimPersoneli", e.target.value)} />
          )}
          {labeledInput(
            "Destek Personeli",
            <input type="number" min="0" style={formInputStyle} placeholder="0" value={form.destekPersoneli} onChange={(e) => updateField("destekPersoneli", e.target.value)} />
          )}

          <strong style={{ display: "flex", alignItems: "center" }}>
            Toplam Personel: {calculateTotalPersonel()}
          </strong>

          <h3 style={{ gridColumn: "1 / 3", marginBottom: 0 }}>Tarih Bilgileri</h3>

          <div>
            <label>Başlangıç Tarihi</label>
            <input type="date" style={{ ...formInputStyle, marginTop: 6 }} value={form.baslangicTarihi} onChange={(e) => updateField("baslangicTarihi", e.target.value)} />
          </div>

          <div>
            <label>Bitiş Tarihi</label>
            <input type="date" style={{ ...formInputStyle, marginTop: 6 }} value={form.bitisTarihi} onChange={(e) => updateField("bitisTarihi", e.target.value)} />
          </div>

          <div>
            <label>Ek Süre Tarihi</label>
            <input type="date" style={{ ...formInputStyle, marginTop: 6 }} value={form.ekSureTarihi} onChange={(e) => updateField("ekSureTarihi", e.target.value)} />
          </div>

          <div>
            <label>Sonlandırma Tarihi</label>
            <input type="date" style={{ ...formInputStyle, marginTop: 6 }} value={form.sonlandirmaTarihi} onChange={(e) => updateField("sonlandirmaTarihi", e.target.value)} />
          </div>

          <strong style={{ gridColumn: "1 / 3" }}>
            Kalan Ay Süre: {calculateKalanAySure()}
          </strong>

          <h3 style={{ gridColumn: "1 / 3", marginBottom: 0 }}>Belge Bilgileri</h3>

          <select style={formInputStyle} value={form.projeBitirmeBelgesi} onChange={(e) => updateField("projeBitirmeBelgesi", e.target.value)}>
            <option value="">Bitirme Belgesi</option>
            <option value="Var">Var</option>
            <option value="Yok">Yok</option>
          </select>

          <select style={formInputStyle} value={form.yazilimTescilBelgesi} onChange={(e) => updateField("yazilimTescilBelgesi", e.target.value)}>
            <option value="">Yazılım Tescil</option>
            <option value="Var">Var</option>
            <option value="Yok">Yok</option>
          </select>

          {form.projeBitirmeBelgesi === "Var" && (
            <>
              <input style={formInputStyle} placeholder="Bitirme Belgesi Kodu" value={form.projeBitirmeBelgesiKodu} onChange={(e) => updateField("projeBitirmeBelgesiKodu", e.target.value)} />
              <input type="date" style={formInputStyle} value={form.projeBitirmeBelgesiTarihi} onChange={(e) => updateField("projeBitirmeBelgesiTarihi", e.target.value)} />
            </>
          )}

          {form.yazilimTescilBelgesi === "Var" && (
            <input type="date" style={formInputStyle} value={form.yazilimTescilTarihi} onChange={(e) => updateField("yazilimTescilTarihi", e.target.value)} />
          )}

          <textarea
            style={{
              ...formInputStyle,
              gridColumn: "1 / 3",
              minHeight: 90
            }}
            placeholder="Açıklama / Not"
            value={form.aciklamaNot}
            onChange={(e) => updateField("aciklamaNot", e.target.value)}
          />
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 32, borderTop: "1px solid #eee", paddingTop: 20 }}>
          <button
            onClick={() => setShowNewProjectModal(false)}
            style={{
              padding: "10px 18px",
              borderRadius: 8,
              border: "1px solid #ccc",
              background: "#fff",
              cursor: "pointer"
            }}
          >
            Kapat
          </button>

          <button
            onClick={saveProject}
            style={{
              padding: "10px 18px",
              borderRadius: 8,
              border: "none",
              background: "#2563eb",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer"
            }}
          >
            Kaydet
          </button>
        </div>
      </div>
    </div>
  );
}
